document.addEventListener("DOMContentLoaded", () => {
    const json = document.getElementById("b2b-prices");
    if (!json) return;

    const prices = JSON.parse(json.textContent);

    let currentVariant = document.querySelector('input[name="id"]').value;

    function getQty() {
        const input = document.querySelector('quantity-selector-component input[ref="quantityInput"]');

        return Number(input?.value || 1);
    }

    function calculate(data, qty){
        if(data.r4 && qty >= data.r4_qty) return data.r4;
        if(data.r3 && qty >= data.r3_qty) return data.r3;
        if(data.r2 && qty >= data.r2_qty) return data.r2;
        if(data.r1 && qty >= data.r1_qty) return data.r1;

        return data.r0;
    }

    function update() {
        const data = prices[currentVariant];

        if (!data) return;

        const qty = getQty();
        const price = calculate(data, qty);

        document.querySelectorAll(".b2b-custom-price").forEach(input => { 
            input.value = price; 
        });

        document.querySelectorAll(".b2b-price").forEach(span => {
            span.innerHTML = new Intl.NumberFormat(
                document.documentElement.lang,
                {
                    style: "currency",
                    currency: Shopify.currency.active
                }
            ).format(price);
        });
    }

    update();

    document.addEventListener("b2b:update-price", () => { update(); });

    document.addEventListener("b2b:variant-changed", (e) => {
        currentVariant = String(e.detail.variantId);
        update();
    });
});